import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { splitTime } from "../../../_helper";
import { useDispatch, useSelector } from "react-redux";
import { fetchSingleCourseLesson } from "../../../Redux/PartnersCourses/PartnersCoursesActions";
import PageTitle from "../../../Components/UI/PageTitle";
import LessonsInCourseForClient from "../../../Components/SingleCourseComponents/LessonsInCourseForClient";
import ValidFeedbackComponent from "../../../assets/lottie/ValidFeedbackSuccess/ValidFeedbackComponent";
import { markLessonAsComplete } from "../../../apis";

const CourseSingleLesson = () => {
  const dispatch = useDispatch();
  const { singleLessonInfo } = useSelector((state) => state?.partnersCourses);
  const { lang } = useSelector((state) => state?.UI);
  const { id, lessonId } = useParams();
  const [completeLesson, setCompleteLesson] = useState(false);

  useEffect(() => {
    if (id && lessonId) {
      dispatch(fetchSingleCourseLesson(id, lessonId));
    }
  }, [id, dispatch, lessonId]);

  useEffect(() => {
    setCompleteLesson(singleLessonInfo?.is_completed);
  }, [singleLessonInfo?.is_completed]);

  const handleCompleteLesson = () => {
    markLessonAsComplete(lessonId)
      .then((response) => {
        if (response.data?.status === true) {
          setCompleteLesson(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <PageTitle
        title={singleLessonInfo[`lesson_name_${lang}`] ?? ""}
        BreadcrumbItems={[
          { title: "Home", link: "/" },
          {
            title: "My Courses",
            link: `/partners/my-courses`,
          },

          {
            title: "Course Details",
            link: `/partners/courses/${id}`,
          },
          { title: `${singleLessonInfo[`lesson_name_${lang}`] ?? "lesson"}` },
        ]}
      />
      <div className="row max-xl:tw-flex-col">
        <div className="col-xl-12">
          <div className="card">
            <iframe
              title={singleLessonInfo[`lesson_name_${lang}`]}
              src={singleLessonInfo?.link}
              width="100%"
              height="480"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>

            <div className="card-body">
              <div className="tw-min-h-9">
                {!completeLesson ? (
                  <div className="tw-flex tw-items-center tw-justify-end">
                    <button
                      className="btn btn-outline-success hover:tw-text-white !tw-m-0 !tw-py-1"
                      onClick={handleCompleteLesson}
                    >
                      Mark as Completed
                    </button>
                  </div>
                ) : (
                  <div className="tw-flex tw-items-center tw-justify-end">
                    <span className="tw-inline-block tw-mx-2">Completed</span>
                    <ValidFeedbackComponent />
                  </div>
                )}
              </div>
              {singleLessonInfo[`lesson_description_${lang}`]}
            </div>
          </div>
        </div>
        <div className="col-xl-8">
          <div className="card">
            <LessonsInCourseForClient id={id} />
          </div>
        </div>
        <div className="col-xl-4">
          {singleLessonInfo?.lesson_type && (
            <div className="card">
              <div className="card-header">Video Category</div>
              <div className="card-body">
                <h1 className="h4 text-capitalize mb-0 tw-text-primary">
                  {singleLessonInfo?.lesson_type}
                </h1>
              </div>
            </div>
          )}

          {singleLessonInfo?.material && (
            <div className="card">
              <div className="card-body">
                <a
                  href={singleLessonInfo?.material?.material_link}
                  className="btn btn-primary btn-block flex-column"
                  target="_blank"
                  rel="noreferrer"
                >
                  <i className="material-icons">get_app</i> Download Files
                </a>
              </div>
            </div>
          )}

          <div className="card">
            <ul className="list-group list-group-fit">
              <li className="list-group-item">
                <div className="media align-items-center">
                  <div className="media-left">
                    <i className="material-icons text-muted-light">schedule</i>
                  </div>
                  <div className="media-body">
                    {splitTime(singleLessonInfo?.duration)?.hours}{" "}
                    <small className="text-muted">hrs</small> &nbsp;{" "}
                    {splitTime(singleLessonInfo?.duration)?.mins}{" "}
                    <small className="text-muted">min</small>
                  </div>
                </div>
              </li>
              <li className="list-group-item">
                <div className="media align-items-center">
                  <div className="media-left">
                    <i className="material-icons text-muted-light">
                      assessment
                    </i>
                  </div>
                  <div className="media-body">{singleLessonInfo?.level}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default CourseSingleLesson;
